import { CustomerAddress } from "../@types/Billing/Customer";
import { UserSubscription } from "../@types/Billing/Subscription";
import {
  create,
  findOne,
  getPortal,
  canTrial,
  getPlanDetails,
} from "../services/billing/customer";

export function useCustomer() {
  async function storeOne(data: CustomerAddress): Promise<boolean> {
    const responseCode = await create(data);

    if (responseCode === 201) {
      return true;
    }

    return false;
  }

  async function isExisting(): Promise<boolean> {
    const responseCode = await findOne();

    if (responseCode === 200) {
      return true;
    }

    return false;
  }

  function generateBillingPortalUrl(): Promise<string> {
    return getPortal();
  }

  async function isTrialEligible(): Promise<boolean> {
    const response = await canTrial();

    if (response) {
      return response.is_eligible;
    }

    return false;
  }

  function getEnabledPlan(): Promise<UserSubscription | null> {
    return getPlanDetails();
  }

  return {
    storeOne,
    isExisting,
    generateBillingPortalUrl,
    isTrialEligible,
    getEnabledPlan,
  };
}
